import axios from "axios";
import { BASE_URL } from "./CONSTANTS";

function getBaseUrl() {
  const envUrl = process.env.REACT_APP_API;
  const host = typeof window !== "undefined" ? window.location.hostname : "";

  // Prefer dev API for demo domain and localhost to avoid hitting production
  if (host.includes("demo.beclutch.club") || host.includes("localhost")) {
    return "https://dev.beclutch.club/api/";
  }

  // Fallback to env, or dev API if env not set
  return envUrl || "https://dev.beclutch.club/api/";
}

const mainAxios = axios.create({
  baseURL: getBaseUrl(),
});

function errorHandler(error) {
  const response = error?.response;

  if (response && response?.status === 401) {
    return Promise.reject(new Error("Unauthorized"));
  }

  if (response && response?.status) {
    return Promise.reject(response);
  }

  return Promise.reject(error);
}

mainAxios.interceptors.request.use(
  (defaultConfig) => defaultConfig,
  (error) => Promise.reject(error)
);

mainAxios.interceptors.response.use(
  (response) => response,
  (error) => errorHandler(error)
);

export default mainAxios;
